import { useInfiniteQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { stockKeys } from "./query-keys";

type Marketplace = components["parameters"]["Marketplace"];

export function useAuditLog(sku: string, mkp: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: stockKeys.audit(sku, mkp),
    queryFn: async ({ pageParam }) => {
      const offset = typeof pageParam === "number" ? pageParam : 0;
      const { data, error } = await apiClient.GET("/v1/stock/{sku}/{mkp}/audit", {
        params: {
          path: { sku, mkp: mkp as Marketplace },
          query: { offset, limit: 50 },
        },
      });
      if (error) throw error;
      return data!;
    },
    getNextPageParam: (lastPage) => lastPage.next_offset ?? undefined,
    initialPageParam: 0,
    enabled: enabled && !!sku && !!mkp,
    staleTime: 30_000,
  });
}
